export class AssetInBaseAsset {
    assetInBaseAssetId: number;
    baseAssetId: number;
    linkedBaseAssetId: number;
    assetInBaseAssetIndex: number;
}